import React, { useEffect, useState } from 'react';
import { Modal, Select, Switch, Spin, Alert, notification } from 'antd';
import axios from 'axios';

const TutorSchoolRestrictions = ({ trainer, open, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [schoolOptions, setSchoolOptions] = useState([]);
  const [isGeneral, setIsGeneral] = useState(false);
  const [selectedSchoolIds, setSelectedSchoolIds] = useState([]);

  const loadData = async () => {
    if (!trainer?.id) return;
    setLoading(true);
    setError(null);
    try {
      const [schoolsRes, restrictionsRes] = await Promise.all([
        axios.get('trainer/schools'),
        axios.get(`trainer/${trainer.id}/restrictions`),
      ]);

      const schools = schoolsRes.data?.list || schoolsRes.data?.data || [];
      setSchoolOptions(
        schools.map((s) => ({ value: s.id, label: s.name }))
      );

      const data = restrictionsRes.data?.data || {};
      setIsGeneral(!!data.is_general);
      setSelectedSchoolIds(Array.isArray(data.school_ids) ? data.school_ids : []);
    } catch (err) {
      const msg = err?.response?.data?.message || 'Veriler yüklenemedi';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open && trainer?.id) {
      loadData();
    }
  }, [open, trainer?.id]);

  const handleSave = async () => {
    setSaving(true);
    try {
      await axios.put(`trainer/${trainer.id}/restrictions`, {
        is_general: isGeneral,
        school_ids: selectedSchoolIds,
      });
      notification.success({ message: 'Okul kısıtlamaları kaydedildi' });
      onClose();
    } catch (err) {
      const msg = err?.response?.data?.message || 'Kaydetme başarısız';
      notification.error({ message: msg });
    } finally {
      setSaving(false);
    }
  };

  const title = trainer
    ? `${trainer.first_name} ${trainer.last_name} — Okul Kısıtlamaları`
    : 'Okul Kısıtlamaları';

  return (
    <Modal
      title={title}
      open={open}
      onOk={handleSave}
      onCancel={onClose}
      confirmLoading={saving}
      okText="Kaydet"
      cancelText="İptal"
      width={520}
      destroyOnClose
    >
      {loading ? (
        <div style={{ textAlign: 'center', padding: 32 }}>
          <Spin />
        </div>
      ) : error ? (
        <Alert type="error" message={error} showIcon />
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '12px 14px',
              background: '#f6f8fa',
              borderRadius: 8,
              border: '1px solid #e8e8e8',
            }}
          >
            <div>
              <strong>Genel (Okulsuz Öğrencileri Kısıtla)</strong>
              <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>
                Okula kayıtlı olmayan bağımsız öğrenciler bu öğretmeni göremez.
              </div>
            </div>
            <Switch checked={isGeneral} onChange={setIsGeneral} />
          </div>

          <div>
            <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>
              Kısıtlı okullar
            </label>
            <Select
              mode="multiple"
              allowClear
              showSearch
              placeholder="Okul seçin"
              style={{ width: '100%' }}
              value={selectedSchoolIds}
              onChange={(vals) => setSelectedSchoolIds(vals || [])}
              options={schoolOptions}
              optionFilterProp="label"
              maxTagCount="responsive"
            />
            <small style={{ color: '#888', display: 'block', marginTop: 8 }}>
              Seçilen okulların öğrencileri bu öğretmeni göremez. Diğer okullar ve
              okulsuz öğrenciler (Genel kapalıysa) görebilir.
            </small>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default TutorSchoolRestrictions;
